import React, { Suspense } from "react";
import useViewportActivation from "../../../hooks/useViewportActivation";

const Slider = React.lazy(() => import("react-slick"));

export default function ComparisonTrustSlider() {
  const [sectionRef, isNearViewport] = useViewportActivation();

  const comparisontrust = [
    {
      logo: "https://api.mobilityinfotechlogistics.com/logo/2988366346.webp",
      alt: "Logo 1",
    },
    {
      logo: "https://api.mobilityinfotechlogistics.com/logo/3806201067.webp",
      alt: "Logo 2",
    },
    {
      logo: "https://api.mobilityinfotechlogistics.com/logo/6023997476.webp",
      alt: "Logo 3",
    },
    {
      logo: "/assets/images/comparison-trust-logo-4.webp",
      alt: "Logo 4",
    },
    {
      logo: "/assets/images/comparison-trust-logo-1.webp",
      alt: "Logo 5",
    },
    {
      logo: "/assets/images/comparison-trust-logo-2.webp",
      alt: "Logo 6",
    },
    {
      logo: "/assets/images/comparison-trust-logo-3.webp",
      alt: "Logo 7",
    },
    {
      logo: "/assets/images/comparison-trust-logo-4.webp",
      alt: "Logo 8",
    },
  ];

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    cssEase: "linear",
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 991,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 767,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 599,
        settings: { slidesToShow: 3 },
      },
    ],
  };

  return (
    <section ref={sectionRef} className="comparison-trust-area">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-12">
            <div className="comparison-trust-main">
              <div className="comparison-trust-left">    
              <p>
                Trusted by 600+ <br />
                Leading Brands Worldwide
              </p>
                </div>
              <div className="comparison-trust-right-slider">
                {isNearViewport && (
                  <Suspense fallback={null}>
                    <Slider {...settings}>
                      {comparisontrust.map((item, index) => (
                        <div className="comparison-trust-box" key={index}>
                          <div className="comparison-trust-inner">
                            <img src={item.logo} alt={item.alt}  className="img-fluid"
                              loading="lazy" />
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </Suspense>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}